import { useLocale } from 'next-intl';

const useAddLocaleToUrl = () => {
  const locale = useLocale();
  return (url: string) => {
    if (locale === 'en' || locale === 'default') return url;

    if (url.startsWith('/') && !url.startsWith('//')) return `/${locale}${url}`;

    return url.replace(/^(https?:\/\/[^/]+)/, `$1/${locale}`);
  };
};

export default useAddLocaleToUrl;
